import React, { useState, useEffect, useCallback } from "react";
import { Select } from "antd";
import { DownloadOutlined, ReloadOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../../loading";
import SearchBox from "../../../components/CustomWidgets/SearchBox";
import "../../../../src/styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import i18next from "i18next";
import { toast } from "react-toastify";
import DateFilter from "../../../components/ui/DateFilter";
import { URLS } from "../../../API/API endpoints";
import axiosInstance from "../../../AxiosInstance";
import moment from "moment";
import DeliveryBoyReportTable from "./DeliveryBoyReportTable";
// Adjust this path to wherever getAllDeliveryBoys actually lives in your project
import { getAllDeliveryBoys } from "../../../API  Functions/DeliveryBoyApis";

const DeliveryBoyReport = () => {
  const { t, i18n } = useTranslation();

  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );

  const [loading, setloading] = useState(false);
  const { Option } = Select;

  const [currentLimit, setCurrentLimit] = useState(10);
  const [currentOffset, setCurrentOffset] = useState(0);
  const [selectedRange, setSelectedRange] = useState("thisMonth");
  const [reportData, setDeliveryBoyReportData] = useState([]);

  const today = dayjs();
  const formatToday = today.format("YYYY-MM-DD");
  const startofMonth = today.startOf("month").format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(startofMonth);
  const [endDate, setEndDate] = useState(formatToday);

  const [allSessions, setAllSessions] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);

  const [selectedDeliveryBoy, setSelectedDeliveryBoy] = useState(null);
  const [allDeliveryBoyData, setAllDeliveryBoyData] = useState([]);

  const [searchByShortCode, setSearchByShortCode] = useState(false);


  const [query, setquery] = useState("");


  useEffect(() => {
    GetSessions();
    GetDeliveryBoyData();
    GetDeliveryBoyWiseReport(
      query,
      selectedSession,
      selectedDeliveryBoy,
      startDate,
      endDate,
      currentOffset,
      currentLimit,
    );
  }, [currentLimit, currentOffset]);

  const GetDeliveryBoyData = async () => {
    try {
      const res1 = await getAllDeliveryBoys({
        company_id,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      });

      if (res1?.result?.status_code === 200) {
        setAllDeliveryBoyData(res1.result?.data);
      } else {
        setAllDeliveryBoyData([]);
      }
    } catch (error) {
      console.error("Error fetching delivery boy list:", error);
      setAllDeliveryBoyData([]);
    }
  };

  const GetSessions = async () => {
    try {
      const response = await axiosInstance.post(URLS.GET_POS_SESSION_LIST, {
        company_id,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      });

      if (response?.data?.result?.status_code === 200) {
        setAllSessions(response.data.result.data);
      } else {
        setAllSessions([]);
      }
    } catch (error) {
      console.error("Error fetching sessions:", error);
      setAllSessions([]);
    }
  };

  const GetDeliveryBoyWiseReport = async (
    query,
    session,
    deliveryBoy,
    start,
    end,
    offset,
    limit,
  ) => {
    try {
      const response = await axiosInstance.post(URLS.GET_DELIVERY_BOY_REPORT, {
        search: searchByShortCode ? "" : query,
        short_code: searchByShortCode ? query : "",
        company_id: company_id,
        offset: offset,
        limit: limit,
        start_date: start,
        end_date: end,
        session_id: session || false,
        delivery_boy_ids: deliveryBoy ? [deliveryBoy] : null,
        lang: i18n.language == "ar" ? "ar_001" : "en_US",
      });
      if (response?.data?.result?.status_code === 200) {
        setDeliveryBoyReportData(response?.data?.result?.data);
      } else {
        setDeliveryBoyReportData([]);
      }
    } catch (error) {
      console.error("Error fetching delivery boy report:", error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  const onSessionChange = (id) => {
    setSelectedSession(id);
    setSelectedDeliveryBoy(null);
    setCurrentLimit(10);
    setCurrentOffset(0);
    GetDeliveryBoyWiseReport(query, id, null, startDate, endDate, 0, 10);
  };

  const onDeliveryBoyChange = (id) => {
    setSelectedSession(null);
    setSelectedDeliveryBoy(id);
    setCurrentLimit(10);
    setCurrentOffset(0);
    GetDeliveryBoyWiseReport(query, null, id, startDate, endDate, 0, 10);
  };

  const handleExport = async () => {
    let payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      company_id: company_id,
      start_date: startDate,
      end_date: endDate,
    };

    try {
      const response = await axiosInstance.post(
        URLS.GET_DELIVERY_BOY_REPORT_EXCEL,
        payload,
      );

      if (response?.data?.result?.status_code == 200) {
        downloadFile(response?.data?.result?.file_base64);
      } else {
        toast.error(response?.data?.result?.status || t("Export failed"));
      }
    } catch (error) {
      console.error("Delivery boy export error:", error);
      toast.error(t("Something went wrong while exporting"));
    }
  };

  const downloadFile = (base64Data) => {
    try {
      if (
        !base64Data ||
        typeof base64Data !== "string" ||
        base64Data.trim() === ""
      ) {
        alert("No valid file data available for download");
        return;
      }

      let cleanBase64 = base64Data
        .trim()
        .replace(/^data:[\w/+-]+;base64,/, "")
        .replace(/^["']|["']$/g, "")
        .replace(/\s/g, "");

      const padLength = 4 - (cleanBase64.length % 4);
      if (padLength < 4) cleanBase64 += "=".repeat(padLength);

      let binaryString = atob(cleanBase64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const header = new Uint8Array(bytes.buffer, 0, 8);
      let mimeType = "application/octet-stream";
      let fileExtension = "bin";

      if (header[0] === 0x50 && header[1] === 0x4b) {
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileExtension = "xlsx";
      } else if (
        header[0] === 0xd0 &&
        header[1] === 0xcf &&
        header[2] === 0x11 &&
        header[3] === 0xe0
      ) {
        mimeType = "application/vnd.ms-excel";
        fileExtension = "xls";
      } else if (new TextDecoder().decode(header).includes(",")) {
        mimeType = "text/csv";
        fileExtension = "csv";
      }

      const blob = new Blob([bytes], { type: mimeType });
      const timestamp = moment().format("YYYY-MM-DD_HH.mm.ss");
      const filename = `${t(
        "delivery_boy_wise_sale",
      )}_${timestamp}.${fileExtension}`;

      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("File download failed:", error);
      alert(`Download failed: ${error.message || "Unknown error"}`);
    }
  };


  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      const context = this;
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      GetDeliveryBoyWiseReport(value, null, null, startDate, endDate, 0, 10);
    }, 1000),
    [searchByShortCode, startDate, endDate],
  );

  const handleRefresh = () => {
    GetDeliveryBoyWiseReport(
      query,
      selectedSession,
      selectedDeliveryBoy,
      startDate,
      endDate,
      currentOffset,
      currentLimit,
    );
  };

  return (
    <>
      <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3">
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden mt-4">
          <div className="">
            <div className="  ">
              <div className="flex flex-col md:flex-row md:items-center justify-between ">
                <div className="flex flex-col gap-3 w-full">

                  {/* ---------- Row 1 ---------- */}
                  <div className="flex justify-between items-center flex-wrap gap-3">

                    {/* Left: Session + Date */}
                    <div className="flex items-center gap-3 flex-wrap">
                      <Select
                        showSearch
                        optionFilterProp="children"
                        className="overflow-hidden md:ms-3"
                        style={{
                          width: 340,
                          minWidth: 200,
                          height: 40,
                        }}
                        placeholder={t("All Sessions")}
                        value={selectedSession || null}
                        onChange={onSessionChange}
                      >
                        <Option value={null}>{t("All Sessions")}</Option>

                        {allSessions.map((session) => (
                          <Option key={session?.id} value={session?.id}>
                            {session?.name}
                          </Option>
                        ))}
                      </Select>

                      <DateFilter
                        setSelectedRange={setSelectedRange}
                        selectedRange={selectedRange}
                        SubmitFilter={(start, end) => {
                          setloading(true);
                          setStartDate(start);
                          setEndDate(end);
                          setCurrentLimit(10);
                          setCurrentOffset(0);

                          GetDeliveryBoyWiseReport(
                            query,
                            selectedSession,
                            selectedDeliveryBoy,
                            start,
                            end,
                            0,
                            10
                          );
                        }}
                      />
                    </div>

                    {/* Right: Download + Refresh */}
                    <div className="flex items-center gap-4 ms-3">
                      <button
                        className="w-48 h-10 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
                        onClick={handleExport}
                      >
                        <DownloadOutlined
                          style={{ fontSize: "1.5em", marginInlineStart: -10 }}
                        />
                        <span>{t("Download in Excel")}</span>
                      </button>

                      <div
                        className="flex items-center text-gray-500 cursor-pointer text-sm"
                        onClick={handleRefresh}
                      >
                        <ReloadOutlined />
                        <span className="ms-2">{t("Refresh")}</span>
                      </div>
                    </div>
                  </div>

                  {/* ---------- Row 2 ---------- */}
                  <div className="flex justify-between items-center flex-wrap gap-3">

                    {/* Left: Search Controls */}
                    <div className="flex items-center justify-center gap-2 ms-3 flex-wrap">
                      <div className="w-[250px]">
                        <SearchBox
                          value={query}
                          searchResult={(values) => {
                            setquery(values);
                            setloading(true);
                            setSelectedSession(null);
                            setSelectedDeliveryBoy(null);
                            debouncedSearch(values);
                          }}
                          placeholder={t("Search by Product")}
                        />
                      </div>

                      <button
                        type="button"
                        onClick={() => setSearchByShortCode(!searchByShortCode)}
                        className={`h-[40px] px-2 rounded-md border text-sm whitespace-nowrap ${searchByShortCode
                            ? "bg-blue-100 border-primaryBlue text-primaryBlue"
                            : "bg-white border-gray-300 text-gray-700"
                          }`}
                      >
                        {t("Search Code")}
                      </button>

                      <Select
                        showSearch
                        optionFilterProp="children"
                        style={{
                          width: 340,
                          minWidth: 200,
                          height: 40,
                        }}
                        placeholder={t("All Delivery Boys")}
                        value={selectedDeliveryBoy || null}
                        onChange={onDeliveryBoyChange}
                      >
                        <Option value={null}>{t("All Delivery Boys")}</Option>

                        {allDeliveryBoyData.map((val) => (
                          <Option key={val?.id} value={val?.id}>
                            {`${val?.name} (${val.phone_no})`}
                          </Option>
                        ))}
                      </Select>
                    </div>

                    {/* Right: Clear Filter */}
                    <button
                      className="h-10 px-4 text-primaryBlue text-sm font-semibold rounded-lg"
                      onClick={() => {
                        setSelectedSession(null);
                        setSelectedDeliveryBoy(null);

                        const today = dayjs();
                        const defaultStart = today.startOf("month").format("YYYY-MM-DD");
                        const defaultEnd = today.format("YYYY-MM-DD");

                        setStartDate(defaultStart);
                        setEndDate(defaultEnd);
                        setSelectedRange("thisMonth");

                        setCurrentLimit(10);
                        setCurrentOffset(0);
                        setquery("");

                        GetDeliveryBoyWiseReport(
                          "",
                          null,
                          null,
                          defaultStart,
                          defaultEnd,
                          0,
                          10
                        );
                      }}
                    >
                      {t("Clear Filter")}
                    </button>

                  </div>
                </div>

                {/* Refresh Button positioned at the far right */}

              </div>


            </div>
          </div>
        </div>
        {loading ? (
          <ShimmerLoader />
        ) : (
          <>
            <DeliveryBoyReportTable
              additionalData={reportData}
              pagination={(values) => {
                setCurrentLimit(values.limit);
                setCurrentOffset(values.offset);
              }}
            />
          </>
        )}
      </div>
    </>
  );
};

export default DeliveryBoyReport;